import { render, staticRenderFns } from "./ChannelsForm.vue?vue&type=template&id=1d634eb8&"
import script from "./ChannelsForm.vue?vue&type=script&lang=js&"
export * from "./ChannelsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports